import { IconButton, Paper, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Dispatch } from "react";
import PopUpMap from "./partials/PopUpMap";
import { ParentSize } from "@visx/responsive";

const GeographicalUnitPopUp = ({
  open,
  setOpen,
  hoveredArea,
  setHoveredArea,
}: {
  open: boolean;
  setOpen: Dispatch<React.SetStateAction<boolean>>;
  hoveredArea: string;
  setHoveredArea: Dispatch<React.SetStateAction<string>>;
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  if (!open) return null;
  return (
    <Stack
      p={1}
      minHeight="35vh"
      minWidth="20vw"
      component={Paper}
      gap={0.5}
      position="absolute"
      sx={{
        top: 275,
        // left: "100%",
        transform: "translateX(320px)",
        zIndex: 2,
      }}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      // left={250}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography color="#1B1B22">Select geographical unit</Typography>
        <IconButton size="small" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Stack>
        <ParentSize parentSizeStyles={{ width: "100%", height: "100%" }}>
          {(parent) => (
            <PopUpMap
              open={open}
              setOpen={setOpen}
              height="30vh"
              width="100%"
              onViewportChange={() => {}}
              hoveredArea={hoveredArea}
              setHoveredArea={setHoveredArea}
            />
          )}
        </ParentSize>
      </Stack>
    </Stack>
  );
};

export default GeographicalUnitPopUp;
